var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{attrs:{"view":"lHh Lpr lFf"}},[_c('q-header',{attrs:{"elevated":""}},[_c('q-toolbar',[_c('q-toolbar-title',[_vm._v(" Project Name ")]),_c('div',[_vm._v("v1.0.1")])],1)],1),_c('q-page-container',[_c('Domains')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }